import { Component, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddressPickerComponent } from '../../../../../../../shared/components/address-picker/address-picker.component';
import { Job } from '../../../../../../../shared/Jobbing/models/Job';

@Component({
  selector: 'app-to-location-form',
  standalone: true,
  imports: [AddressPickerComponent, ReactiveFormsModule],
  templateUrl: './to-location-form.component.html',
  styleUrl: './to-location-form.component.scss'
})
export class ToLocationFormComponent {
  @Input()
  formGroup!: FormGroup;

  @Input()
  updateEmitter: EventEmitter<Job> | null = null;

  isInitialized: boolean = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    if (!this.formGroup.get('jobTo')) {
      this.formGroup.addControl('jobTo', this.fb.group({}));
    }
    this.formGroup.setControl('jobTo', this.fb.group({
      onSite: this.fb.control(false),
      contact: this.fb.group({
        name: this.fb.control(''),
        phone: this.fb.control(''),
        email: this.fb.control('', [Validators.email]),
      }),
      addressSelection: this.fb.group({}),
      preciseLocationOptions: this.fb.group({})
    }));

    this.formGroup.get('jobFrom')?.get('onSite')?.valueChanges.subscribe((value) => {
      if (value) {
        this.formGroup.setControl('jobTo', this.fb.group({}));
      }
      this.formGroup.updateValueAndValidity();
    });

    this.isInitialized = true;
  }

  getFormGroup() {
    if (!this.formGroup.get('jobTo')) {
      this.initializeForm();
    }
    return this.formGroup.get('jobTo') as FormGroup;
  }
}
